import { getTimestamp, addToCart } from 'util.helpers'
import { EVENTS, subscribe } from 'util.pubsub'

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor () {
      super()
      console.log('==== new product-form constructor');
      this.form = this.querySelector('form')
      this.submitButton = this.querySelector('button[type="submit"]')
      this.submitButtonTextSpan = this.submitButton?.querySelector('span:not(.button__divider):not(.button__price-compare):not(.button__price)')
      this.textAddToCart = this.submitButton?.dataset.addToCartText || 'Add to Cart'
      this.textSoldOut = this.submitButton?.dataset.soldOutText || 'Sold Out'
      this.textUnavailable = this.submitButton?.dataset.unavailableText || 'Unavailable'
      this.cart = document.querySelector('mini-cart')
      this.variantInput = this.querySelector('input[name="id"]')
      this.quantityInput = this.querySelector('input[name="quantity"]')
      this.planInput = this.querySelector('input[name="selling_plan"]')
      this.section = this.closest('.shopify-section')
      this.stickyButton = this.section?.querySelector('.product-sticky-purchase .js-add-to-cart');
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this))
      }
      
      this.unsubscribeVariantChange = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
      this.unsubscribeQtyChange = subscribe(EVENTS.qtyChange, this.handleQtyChange.bind(this))
      this.unsubscribePlanChange = subscribe(EVENTS.planChange, this.handlePlanChange.bind(this))
    }

    disconnectedCallback() {
      if (this.unsubscribeVariantChange) {
        this.unsubscribeVariantChange()
      }
      if (this.unsubscribeQtyChange) {
        this.unsubscribeQtyChange()
      }
      if (this.unsubscribePlanChange) {
        this.unsubscribePlanChange()
      }
    }

    get sectionId() {
      return this.getAttribute('section-id')
    }

    get productId() {
      return this.getAttribute('product-id')
    }

    addingStart() {
      const buttons = this.stickyButton ? [this.submitButton, this.stickyButton] : [this.submitButton]
      buttons.forEach(button => {
        button.querySelector('.button-main-content')?.classList.add('hidden');
        button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      });
    }

    addingEnd() {
      const buttons = this.stickyButton ? [this.submitButton, this.stickyButton] : [this.submitButton]
      buttons.forEach(button => {
        button.querySelector('.button-main-content')?.classList.remove('hidden');
        button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      });
    }

    handleVariantChange(event) {
      const { productId, sectionId, variant } = event.detail
      if (this.variantInput && productId == this.productId && sectionId == this.sectionId) {
        if (variant) {
          this.variantInput.value = variant.id
          if (this.submitButtonTextSpan) this.submitButtonTextSpan.textContent = variant.available ? this.textAddToCart : this.textSoldOut
          this.submitButton.toggleAttribute('disabled', !variant.available)
        } else {
          this.variantInput.value = ''
          if (this.submitButtonTextSpan) this.submitButtonTextSpan.textContent = this.textUnavailable
          this.submitButton.setAttribute('disabled', true)
        }
      }
    }

    handleQtyChange(event) {
      const { value } = event.detail
      if (this.quantityInput) {
        this.quantityInput.value = value
      }
    }

    async onSubmit (event) {
      event.preventDefault()

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      this.handleErrorMessage()
      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading')

      try {
        const ts = getTimestamp()
        this.form.querySelectorAll('[data-property-ts]').forEach((input) => {
          input.value = ts
        })

        const formData = new FormData(this.form)
        formData.append('sections', 'mini-cart')
        this.cart?.preload()
        this.addingStart()
        const response = await addToCart(formData)
        this.handleSuccess(response)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-disabled')
        this.addingEnd()
      }
    }

    handleSuccess (data) {
      this.cart?.open(data)
    }

    handleError (error) {
      this.handleErrorMessage(error?.description || error.message || 'An error occurred')
    }

    handleErrorMessage (message = false) {
      const errorElement = this.querySelector('[data-error-message]')
      if (!errorElement) return

      errorElement.classList.toggle('hidden', !message)
      if (message) {
        errorElement.textContent = message
      }
    }

    handlePlanChange(event) {
      const { productId, sectionId, cadence, planId } = event.detail
      if (productId == this.productId && sectionId == this.sectionId) {
        console.log('form handlePlanChange', event);
        if (cadence == 'one-time') {
          this.planInput.value = ''
        }
        if (cadence == 'subscription') {
          this.planInput.value = planId
        }
      }
    }    
  }

  customElements.define('product-form', ProductForm)
}
